/** One shared <audio> for the homepage examples — only one sample plays at a time. */
const state = { key: null, status: "idle", progress: 0, position: 0, duration: 0 };
const subs = new Set();
let audio = null;

function emit() { subs.forEach((fn) => fn({ ...state })); }

function ensureAudio() {
  if (audio || typeof Audio === "undefined") return audio;
  audio = new Audio();
  audio.preload = "none";
  audio.addEventListener("playing", () => { state.status = "playing"; emit(); });
  audio.addEventListener("pause", () => { if (state.status !== "idle") { state.status = "paused"; emit(); } });
  audio.addEventListener("waiting", () => { state.status = "loading"; emit(); });
  audio.addEventListener("timeupdate", () => {
    const d = audio.duration || 0;
    state.position = audio.currentTime || 0;
    state.duration = d;
    state.progress = d ? Math.min(1, audio.currentTime / d) : 0;
    emit();
  });
  audio.addEventListener("ended", () => { state.status = "idle"; state.progress = 0; state.position = 0; emit(); });
  audio.addEventListener("error", () => { state.status = "error"; emit(); });
  return audio;
}

export function subscribe(fn) { subs.add(fn); fn({ ...state }); return () => subs.delete(fn); }

export function getShowcaseState() { return { ...state }; }

export function toggleShowcase(key, url) {
  const a = ensureAudio();
  if (!a) return;
  if (state.key === key && state.status === "playing") { a.pause(); return; }
  if (state.key === key && state.status === "paused") { a.play().catch(() => { state.status = "error"; emit(); }); return; }
  state.key = key; state.status = "loading"; state.progress = 0; state.position = 0; state.duration = 0;
  emit();
  a.src = url;
  a.currentTime = 0;
  a.play().catch(() => { state.status = "error"; emit(); });
}

export function seekShowcase(fraction) {
  if (!audio || !audio.duration) return;
  audio.currentTime = Math.max(0, Math.min(audio.duration, fraction * audio.duration));
}

export function stopShowcase() {
  if (!audio) return;
  audio.pause();
  state.status = "idle"; state.key = null; state.progress = 0; state.position = 0;
  emit();
}

export function _resetForTests() {
  audio = null;
  Object.assign(state, { key: null, status: "idle", progress: 0, position: 0, duration: 0 });
  subs.clear();
}
